import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { IconRaiseHand } from '../../../base/icons/svg';
import ContextMenuItem from '../../../base/ui/components/web/ContextMenuItem';
import { requestModeratorForAuthentication } from '../../../e2ee/functions';
const RequestModeratorAuthnButton = ({ dispatch, participantID }) => {
    const { t } = useTranslation();
    const _handleClick = useCallback(() => {
        requestModeratorForAuthentication(dispatch, participantID);
    }, [dispatch, participantID]);
    return (React.createElement(ContextMenuItem, { accessibilityLabel: t('e2ee.requestModeratorVerify'), className: 'requestModeratorVerify', icon: IconRaiseHand, id: `requestModeratorVerify_${participantID}`, onClick: _handleClick, text: t('e2ee.requestModeratorVerify') }));
};
function _mapStateToProps(state, ownProps) {
    const { participantID } = ownProps;
    return {
        _participantID: participantID
    };
}
export default connect(_mapStateToProps)(RequestModeratorAuthnButton);
